import { defineStore } from 'pinia';
import { ref } from 'vue';

export const useMeilisearchStore = defineStore('meilisearchStore', () => {
    const tenantToken = ref<string | null>(null);

    return {
        tenantToken
    };
}); 
